import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './step1.scss';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { DatePicker } from 'antd';
import { withRouter } from '../../WithRouterHOC';

const DateFormat = 'YYYY-MM-DD';
const defaultDate = '2000-01-01';

class Step1 extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sex: null,
      birthday: defaultDate, // 生日
    };
  }

  changeSex = (sex) => {
    this.setState({ sex });
    this.props.nextBtnStatus(false);
  };

  // 返回 step1 的 state
  getState = () => {
    const { sex, birthday } = this.state;
    return { sex, birthday };
  };
  // 生日选择
  changeBirthday = (data, birthday) => {
    const { sex } = this.state;
    const birthdayDate = birthday || null;

    this.setState({ birthday: birthdayDate, sex }, () => {
      if (sex != null) {
        this.props.nextBtnStatus(false);
      } else {
        this.props.nextBtnStatus(true);
      }
    });
  };

  // 禁止选择的日期
  disabledDate = (current) => {
    return current && current > dayjs().subtract(18, 'year');
  };

  render() {
    const { sex, birthday } = this.state;
    return (
      <div className="perfect-step-1">
        <div className="step-header">
          <h2 className="step-title">请选择你的性别&生日</h2>
        </div>
        <div className="step-sex-radio">
          <div
            className={`sex-item sex-item-1 ${sex != null && !!sex ? 'active' : ''}`}
            onClick={() => this.changeSex(1)}
          />
          <div
            className={`sex-item sex-item-0 ${sex != null && !sex ? 'active' : ''}`}
            onClick={() => this.changeSex(0)}
          />
        </div>
        <DatePicker
          className="birthday-date"
          format={DateFormat}
          placeholder="请选择出生日期"
          defaultValue={dayjs(defaultDate, DateFormat)}
          defaultPickerValue={dayjs('2000-01-01', DateFormat)}
          value={birthday ? dayjs(birthday, DateFormat) : null}
          disabledDate={this.disabledDate}
          locale={locale}
          onChange={this.changeBirthday}
          suffixIcon={<span className="date-suffix-icon" />}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(Step1, { withRef: true })
);
